import misCellaneous from "../components/views/miscellaneous/misCellaneous.vue";
import misCellaneousCreate from "../components/views/miscellaneous/misCellaneousCreate.vue";

const routes = [
  {
    path: "miscellaneous",
    component: misCellaneous,
    name: "miscellaneous",
    meta: {
      description: "List of Miscellaneous",
      title: "Miscellaneous",
      requiresAuth: true,
    },
  },
  {
    path: "miscellaneous/miscellaneouscreate/:_id",
    component: misCellaneousCreate,
    name: "miscellaneouscreate",
    meta: {
      // description: "Add a new Miscellaneous",
      title: "Add / Update Miscellaneous",
      requiresAuth: true,
    },
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/miscellaneous.route.js